// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__d1KBd","fadeInDown":"SectionHeader_fadeInDown__71fdN","subtitle":"SectionHeader_subtitle__1rXQe"};